/** Domain service module: user.js */
import { request } from '../http/request'
import { API_BASE_URL } from './config'

class UserService {
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/user/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  update(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _resultMe = await request(`${API_BASE_URL}/user/update`, 'post', data)
        resolve(_resultMe?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  delete(user_id) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/user/delete/${user_id}`, 'delete')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
}

export const user = new UserService()
export default user
